export default "__VITE_PUBLIC_ASSET__99fddfb7__"